import { render } from "./illegal-bid-count.vue?vue&type=template&id=71ff542b&scoped=true"
import script from "./illegal-bid-count.vue?vue&type=script&lang=js"
export * from "./illegal-bid-count.vue?vue&type=script&lang=js"

import "./illegal-bid-count.vue?vue&type=style&index=0&id=71ff542b&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ff542b"]])

export default __exports__